import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import t from "../translations";

type Props = {
  open: boolean;
  skippedCount: number;
  submitting: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

export default function ConfirmSkippedEntriesDialog({
  open,
  skippedCount,
  submitting,
  onCancel,
  onConfirm,
}: Props) {
  return (
    <Dialog open={open} onClose={() => (submitting ? undefined : onCancel())}>
      <DialogTitle>{t.ConfirmSkippedSaveTitle}</DialogTitle>
      <DialogContent>
        <DialogContentText>{t.ConfirmSkippedSaveBody(skippedCount)}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} disabled={submitting}>
          {t.ConfirmSkippedSaveCancel}
        </Button>
        <Button
          onClick={onConfirm}
          color="error"
          variant="contained"
          disabled={submitting}
          startIcon={
            submitting ? <CircularProgress size={16} color="inherit" /> : undefined
          }
          data-testid="rules-tab.confirm-skipped-save"
        >
          {t.ConfirmSkippedSaveConfirm}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
